import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { DocumentImageSize } from '@/lib/types';

export interface useGetImageOptions {
  shouldFetch?: boolean;
}

export function getImageCacheKey(
  documentEntityId: string | undefined,
  documentSize: DocumentImageSize = DocumentImageSize.s,
) {
  return `/api/Document/GetImage?documentEntityId=${documentEntityId}&documentSize=${documentSize}`;
}

export function useGetImage(
  documentEntityId: string | undefined,
  documentSize: DocumentImageSize = DocumentImageSize.s,
  options?: useGetImageOptions,
) {
  const mergedOptions: useGetImageOptions = {
    shouldFetch: true,
    ...options,
  };

  const { documentApi } = usePrivate();

  const results = useSWR(
    documentApi && documentEntityId && mergedOptions.shouldFetch
      ? getImageCacheKey(documentEntityId, documentSize)
      : null,
    () =>
      documentApi?.apiDocumentGetImageGet(documentEntityId, documentSize, {
        responseType: 'blob',
      }),
    {
      onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
        if (retryCount > 1) {
          console.error('[BREEDLOGIC] <Image>', error);
          return;
        }

        setTimeout(() => revalidate({ retryCount }), 1000);
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !documentApi;

  return { ...results, isLoadingOrValidating };
}
